import { IconButton, Tooltip } from "@mui/material/node";
import { useState } from 'react';
import ForumIcon from '@mui/icons-material/Forum';
import { CommentsDialog } from '../../Dialogs/commentsDialog';
import { useTheme } from '@mui/material/styles';

export const ShowCommentsButton = () => {
    const [showCommentsDialogOpen, setShowCommentsDialogOpen] = useState(false);
    const theme = useTheme();

    return (
        <>
            <IconButton aria-label="Refresh layout" onClick={() => { setShowCommentsDialogOpen(true); }} color="inherit" sx={{ m: 0.5 }}>
                <Tooltip title="Show Comments">
                    <ForumIcon sx={{ color: theme.palette.menuIcon.main }} />
                </Tooltip>
            </IconButton>
            <CommentsDialog onOpen={showCommentsDialogOpen} onClose={() => { setShowCommentsDialogOpen(false) }}></CommentsDialog>
        </>
    );
}
